import type { CharacterId } from "../characters";
import type { PrimitiveBlueprint } from "./types";
import { PLAYER_BLUEPRINT } from "./blueprints/player";
import { BARBARIAN_BLUEPRINT } from "./blueprints/barbarian";

/**
 * Get the avatar blueprint for a given character ID
 * @param characterId - The character ID
 * @returns The primitive blueprint for that character's avatar
 */
export function getCharacterAvatar(characterId: CharacterId): PrimitiveBlueprint {
  switch (characterId) {
    case "warrior":
      return PLAYER_BLUEPRINT;
    case "barbarian":
      return BARBARIAN_BLUEPRINT;
    default:
      // Default to warrior if unknown character
      return PLAYER_BLUEPRINT;
  }
}
